import {useState, useUrlParams} from 'services/hooks'
import {useDebounce} from 'use-debounce'
import {useEffect} from 'react'
import {useSearchParams} from 'react-router-dom'

const useSearchBar = () => {
    const [searchParams] = useSearchParams()
    const [urlParams, setUrlParam] = useUrlParams()

    console.log('urlParams', urlParams)

    const [searchTerm, setSearchTerm] = useState(
        searchParams.get('search') || ''
    )
    const [debouncedSearchTerm] = useDebounce(searchTerm, 600)

    useEffect(() => {
        console.log('debouncedSearchTerm', debouncedSearchTerm)
        setUrlParam('search', debouncedSearchTerm)
    }, [debouncedSearchTerm, setUrlParam])

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value)
    }

    return {
        searchTerm,
        handleSearchChange,
    }
}

export default useSearchBar
